import * as types from './action-types';
import services from '../../../../services';
import selectors from './state-selectors';
import loanSelectors from '../../../../selectors/loan';
import util from '../../../../util';

const loanSelector = loanSelectors.loanSelector;
const api = services.coreAPIInstance;

const pullCreditUnfreeze = () => ({
    asyncAction: () => api.pullCreditUnfreeze(),
    type: types.PULL_CREDIT,
});

const pullCredit = () => (dispatch, getState) => {
    dispatch(pullingCredit());
    const loanId = loanSelector.getLoanId(getState());
    return api.pullCredit(loanId)
        .then((response) => dispatch(succeededPullingCredit(response)))
        .then(() => handleRouting(getState()))
        .catch((error) => {
            dispatch(failedPullingCredit(error));
        });
};

const handleRouting = function (state) {
    const loanStatusCode = loanSelector.getStatusCode(state);
    const reportStatus = selectors.getCode(state);
    if (reportStatus === 'CREDIT_PULL_SUCCESS') {
        loanStatusCode === 400 ? util.router.route('loan-overview') : util.router.route('loan-options/');
    }
};

const reset = () => ({
    type: types.PULL_CREDIT_RESET,
});

export const pullingCredit = () => ({
    type: types.PULL_CREDIT_PENDING
});

export const failedPullingCredit = (error) => ({
    type: types.PULL_CREDIT_FAILURE,
    error: error
});

export const succeededPullingCredit = (response) => ({
    type: types.PULL_CREDIT_SUCCESS,
    res: {
        code: response.status
    }
});

export default {
    pullCreditUnfreeze,
    pullCredit,
    reset
};
